import React, { useEffect, useState } from 'react'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import Carousel from '../../ui/Carousel/Carousel'
import './PortfolioGallery.sass'
import i1 from './assets/1.jpg'
import i2 from './assets/2.jpg'
import i3 from './assets/3.jpg'
import i4 from './assets/4.jpg'
import i5 from './assets/5.jpg'
import i6 from './assets/6.jpg'
import i7 from './assets/7.jpg'
import i8 from './assets/8.jpg'

function PortfolioGallery() {
  const gallery = [i1, i2, i3, i4, i5, i6, i7, i8]

  return (
    <section className="PortfolioGallery">
      <div className="DefaultContainer">
        <SectionTitle title="Мы в работе" />
        <Carousel
          element="PortfolioGallery-Carousel"
          options={{
            type: 'carousel',
            gap: 24,
            perView: 3,
            hoverpause: true,
            // autoplay: 5000,
            // useDots: true,
            useArrows: true,
            breakpoints: {
              // 1200: { perView: 3 },
              // 992: { perView: 2 },
              576: { perView: 1 },
            },
          }}
        >
          {gallery.map((p) => (
            <a href={p} data-fancybox>
              <img src={p} alt="" />
            </a>
          ))}
        </Carousel>
      </div>
    </section>
  )
}

export default PortfolioGallery
